import {
  Exact,
  GqlListBankAccountsQuery,
  GqlMxBankAccount,
  StatusTypes,
  useListBankAccountsQuery,
} from 'types/graphql';
import type { ApolloQueryResult } from '@apollo/client';
import { Nullish } from 'shared/utils/type-utils';
import { AGGREGATORS } from 'src/payments/constants';

type UseBankAccountsUtils = {
  bankAccounts: (Pick<
    GqlMxBankAccount,
    'accountAlias' | 'bankName' | 'billingAddressId' | 'entityId' | 'id' | 'lastDigits' | 'status'
  > & { _typename?: 'MxBankAccount' | undefined })[];
  connectionStatus: Nullish | string;
  mxWidgetUrl: Nullish | string;
  billingAddressId: Nullish | string;
  loading: boolean;
  statusAggregatorError: boolean;
  refetchBankAccountData: (
    variables?: Exact<{ aggregator: string }> | undefined
  ) => Promise<ApolloQueryResult<GqlListBankAccountsQuery>>;
};

export const useListBankAccounts = (): UseBankAccountsUtils => {
  const { data, refetch, loading } = useListBankAccountsQuery({
    variables: { aggregator: AGGREGATORS.MX },
    skip: true,
  });

  const bankAccounts = data?.listBankAccounts?.bankAccounts ?? [];
  const connectionStatus = bankAccounts[0]?.mx?.connectionStatus;
  const mxWidgetUrl = bankAccounts[0]?.mx?.widgetUrl;
  const billingAddressId = bankAccounts[0]?.billingAddressId;
  const statusAggregatorError = bankAccounts[0]?.status === StatusTypes.statusAggregatorError;
  const refetchBankAccountData = refetch;

  return {
    bankAccounts,
    connectionStatus,
    mxWidgetUrl,
    billingAddressId,
    statusAggregatorError,
    refetchBankAccountData,
    loading,
  };
};
